<template>
    <div class="settings-component mb-5">
        <div v-if="!loader">
            <!-- HEADER -->
            <h1>{{ $l10n.__('Réglages') }}</h1>

            <!-- TAB NAV -->
            <div class="flex-row setting-nav jc-center semibold fs-14">
                <router-link :to="{ name: 'settings.home.general' }">
                    <div class="flex-row ai-center" :class="{ selected: state === 'settings' }">
                        <span class="lh-20">{{ $l10n.__('Général') }}</span>
                    </div>
                </router-link>
                <router-link
                    :to="{
                        name: 'settings.home.internal',
                    }"
                >
                    <div class="flex-row ai-center" :class="{ selected: state === 'plugins' }">
                        <span class="lh-20">{{ $l10n.__('Module Sellsy') }}</span>
                    </div>
                </router-link>
                <router-link
                    :to="{
                        name: 'settings.home.external',
                    }"
                >
                    <div class="flex-row ai-center" :class="{ selected: state === 'externals' }">
                        <span class="lh-20">{{ $l10n.__('Module Externe') }}</span>
                    </div>
                </router-link>
            </div>
            <router-view></router-view>
        </div>

        <!-- LOADER -->
        <div v-else class="prelative">
            <preloader :display="loader" />
        </div>
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import { createNamespacedHelpers } from 'vuex';
const settingsStore = createNamespacedHelpers('settingsStore');

export default {
    components: {
        Preloader,
    },
    data() {
        return {
            loader: true,
        };
    },
    computed: {
        ...settingsStore.mapGetters({
            externalPlugins: 'getExternalPlugins',
            internalPlugins: 'getInternalPlugins',
        }),
        state() {
            return this.$route.meta.state;
        },
    },
    created() {
        this.fetchMenu().finally(() => {
            this.loader = false;
        });
    },
    methods: {
        ...settingsStore.mapActions(['fetchMenu']),
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.settings-component {
    .setting-nav {
        a {
            div:not(.selected) > span {
                color: $gray-100;
            }
            div {
                background-color: $white;
                cursor: pointer;
                transition: background-color 100ms cubic-bezier(0, 0, 0.3, 1);

                &:hover {
                    background-color: $primary-05;
                }

                span {
                    font-size: 14px;
                }
            }
            .selected {
                background-color: $primary-50;
                color: $white;
                &:hover {
                    background-color: #3a53ca;
                }
            }
            div {
                border: 1px solid $gray-40;
                border-bottom: 0 !important;
                gap: 4px;
                padding: 6px 24px;
            }
        }

        a:first-child > div {
            border-top-left-radius: 4px;
        }

        a:not(:last-child) > div {
            border-right: none;
        }

        a:last-child > div {
            border-top-right-radius: 4px;
        }
    }
}
</style>
